import {
  type ContractDataType,
  type ProductOfDayDataType,
} from '../types/contract';

const getContractExtraStarPoints = (
  contract: ContractDataType,
  productsOfDay: ProductOfDayDataType[],
): number => {
  const productKeys =
    contract.type === 'Blitz'
      ? Object.values(contract.stepsData || {}).flatMap((step) =>
          Object.keys(step || {}),
        )
      : Object.keys(contract.data || {});

  const extraPoints = productKeys.reduce(
    (acc, product) =>
      acc +
      (productsOfDay?.find(({ name }) => name === product)?.extraStarPoints ||
        0),
    0,
  );

  return extraPoints;
};

export { getContractExtraStarPoints };
